import type { CityConfig } from "../city-template/types";

export const marionIAConfig: CityConfig = {
  city: "Marion",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "marion-ia",
  route: "/cities/marion-ia",
  title: "Emergency Passport Marion, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Marion, IA — as fast as 24 hours. Serving Linn County and Cedar Rapids metro. A+ BBB rated registered State Dept. courier serving Rockwell Collins and Collins Aerospace professionals, Uptown Marion business district, and East Central Iowa travelers. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Marion, IA",
  heroSubtitle: "Collins Aerospace international deployment to Singapore with a week's notice and your passport expired? Uptown Marion business trip to Europe and documents aren't ready? Family vacation to Mexico departing from CID in 5 days? We help Marion and East Central Iowa residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Marion%20Iowa%20historic%20Uptown%20Marion%20district%20with%20brick%20storefronts%20and%20tree%20lined%20streets%20modern%20Collins%20Aerospace%20campus%20nearby%20Cedar%20Rapids%20metro%20East%20Central%20Iowa%20at%20golden%20hour%20warm%20sunlight%20community%20atmosphere&width=1800&height=700&seq=marion-ia-hero-2026&orientation=landscape",
  heroImageAlt: "Marion Iowa historic Uptown district and Collins Aerospace campus Cedar Rapids metro area at golden hour",
  geoPosition: "42.0333;-91.5976",
  geoPlacename: "Marion, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 245 miles east of Marion via I-380 and I-80",
  },
  nearbyCitiesZips: [
    { name: "Marion", zips: "52302" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Hiawatha", zips: "52233" },
    { name: "Robins", zips: "52328" },
    { name: "Alburnett", zips: "52202" },
    { name: "Central City", zips: "52214" },
    { name: "Mount Vernon", zips: "52314" },
    { name: "Lisbon", zips: "52253" },
    { name: "Springville", zips: "52336" },
    { name: "Center Point", zips: "52213" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Coralville", zips: "52241" },
    { name: "North Liberty", zips: "52317" },
    { name: "Anamosa", zips: "52205" },
    { name: "Vinton", zips: "52349" },
    { name: "Waterloo", zips: "50701–50707" },
    { name: "Dubuque", zips: "52001–52004" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "Davenport", zips: "52801–52807" },
    { name: "Independence", zips: "50644" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent East Central Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Cedar Rapids Metro", desc: "Serving Marion, Hiawatha, Robins, and Linn County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
    { name: "Fast passport renewal in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Emergency passport help in Coralville, IA", route: "/cities/coralville" },
    { name: "Urgent passport services in Waterloo, IA", route: "/cities/waterloo-ia" },
    { name: "Same-day passport help in Dubuque, IA", route: "/cities/dubuque" },
    { name: "Passport courier services in Des Moines, IA", route: "/cities/des-moines" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Marion remotely via secure courier. We do not have a walk-in office in Marion — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Linn County and the entire Cedar Rapids metro region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Linn County and the Cedar Rapids metro region including Marion, Hiawatha, Robins, and surrounding East Central Iowa communities",
  serviceAreaIntro: "From the Collins Aerospace campus with its global engineering workforce to the historic Uptown Marion district with award-winning restaurants and boutiques, from the Lowe Park Arts and Environment Center to the growing residential communities along Highway 13 and 151, from the Marion Independent and Linn-Mar school districts with international programs to the nearby Eastern Iowa Airport providing global connections — Fast Passport Center serves the entire Marion region. We regularly help travelers from Marion, Hiawatha, Robins, and Cedar Rapids get their passports fast without the 4-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Marion neighborhoods and the surrounding Cedar Rapids metro area including Hiawatha, Robins, Alburnett, Central City, Mount Vernon, Lisbon, and Springville. If you are anywhere in Linn County or the East Central Iowa region, we have you covered.",
  howItWorksIntro: "Most Marion travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "East Central Iowa travelers often face a 4-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Marion and Linn County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Marion? Here are the most common ones we hear from Cedar Rapids metro travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Marion travelers with immediate departure needs — as fast as 24 hours for urgent international flights from CID.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Linn County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "David R.",
      location: "Marion, IA",
      rating: 5,
      text: "Collins Aerospace deployment to Singapore — 5 days notice and my passport wasn't current. Fast Passport Center renewed it in 2 days. My team lead was shocked. Now the entire avionics division uses them for international deployments.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer S.",
      location: "Marion, IA",
      rating: 5,
      text: "Family cruise from Fort Lauderdale — realized our kids' passports expired 4 days before departure. Fast Passport Center got all three done in 3 days. We made the ship with hours to spare. The kids still talk about it!",
      service: "Child Passport",
    },
    {
      name: "Tom and Lisa K.",
      location: "Hiawatha, IA",
      rating: 5,
      text: "25th anniversary trip to Ireland booked months ago — passports expired and we forgot until the week before. Fast Passport Center renewed both in 3 days. We toasted our anniversary in a Dublin pub right on schedule!",
      service: "Passport Renewal",
    },

  ],
  facilities: [
    {
      id: "marion-ia-1",
      name: "Marion Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1301 7th Ave",
      city: "Marion",
      state: "IA",
      zip: "52302",
      phone: "(319) 377-4651",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Marion city center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Marion facility. Serves Linn County. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-ia-2",
      name: "Linn County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "935 2nd St SW",
      city: "Cedar Rapids",
      state: "IA",
      zip: "52404",
      phone: "(319) 892-5420",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "8 miles southwest in Cedar Rapids",
      website: "https://www.linncountyiowa.gov/recorder",
      websiteLabel: "Linn County Recorder",
      notes: "Accepts passport applications. Extended weekday hours. Good alternative to post office.",
      icon: "ri-government-line",
    },
    {
      id: "marion-ia-3",
      name: "Hiawatha Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1100 Emmons St",
      city: "Hiawatha",
      state: "IA",
      zip: "52233",
      phone: "(319) 393-3911",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles west of Marion",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hiawatha and western Linn County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-ia-4",
      name: "Cedar Rapids Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "615 6th Ave SE",
      city: "Cedar Rapids",
      state: "IA",
      zip: "52401",
      phone: "(319) 399-4801",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "8 miles southwest of Marion",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest USPS facility in the Cedar Rapids metro. Extended hours available.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-ia-5",
      name: "Mount Vernon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "123 1st St NW",
      city: "Mount Vernon",
      state: "IA",
      zip: "52314",
      phone: "(319) 895-8521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles east of Marion",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mount Vernon and Cornell College community. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-ia-6",
      name: "Anamosa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "117 S Ford St",
      city: "Anamosa",
      state: "IA",
      zip: "52205",
      phone: "(319) 462-3811",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "18 miles northeast of Marion",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Jones County and Anamosa State Penitentiary staff community. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photo shops in the Cedar Rapids metro often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Linn County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Marion applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Linn-Mar school district families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Collins Aerospace travelers often assume corporate travel handles everything. Always check your passport 6 months before international assignments.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Marion." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Marion address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Marion before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Marion for travelers with urgent international flights from CID. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Marion?", a: "Fast Passport Center offers fast passport renewal in Marion in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Marion?", a: "The nearest regional passport agency to Marion is the Chicago Passport Agency, approximately 245 miles east via I-380 and I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Marion without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Marion?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 4-plus hours from Marion — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Linn County and Cedar Rapids metro residents." },
    { q: "Do you serve Collins Aerospace employees?", a: "Absolutely. Fast Passport Center regularly serves Collins Aerospace and Rockwell Collins professionals needing fast passports for international deployments and business travel. Our courier service handles everything online — you never leave your desk. Dozens of Marion aerospace professionals trust us every month." },
    { q: "Can I expedite a child passport in Marion?", a: "Yes. Fast Passport Center expedites child passports in Marion for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Linn-Mar and Marion Independent school district families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Marion with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Marion", address: "5491 Business Hwy 151, Marion, IA 52302", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Marion", address: "1225 7th Ave, Marion, IA 52302", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Cedar Rapids", address: "3601 29th Ave SW, Cedar Rapids, IA 52404", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Hiawatha", address: "1100 N Center Point Rd, Hiawatha, IA 52233", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Cedar Rapids", address: "1530 1st Ave NE, Cedar Rapids, IA 52402", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Cedar Rapids", address: "2320 Edgewood Rd SW, Cedar Rapids, IA 52404", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Marion Driver's License",
      address: "3720 Katz Dr, Marion, IA 52302",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Linn County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Cedar Rapids Driver's License",
      address: "230 3rd Ave SW, Cedar Rapids, IA 52404",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Downtown Cedar Rapids location. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Iowa City Driver's License",
      address: "1700 S 1st Ave, Iowa City, IA 52240",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Johnson County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "15 miles southwest of Marion",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Primary airport for Eastern Iowa with direct flights nationwide. About 20 minutes from Marion.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: true,
    },
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "80 miles southeast of Marion",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Major regional airport with national connections. About 1 hour 20 minutes from Marion.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Airport",
      featured: false,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "120 miles west of Marion",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport. About 1 hour 45 minutes from Marion.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Iowa Department of Public Health Vital Records. Online, mail, or in-person options for Linn County residents.", url: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through IDPH Vital Records. Required for estate, insurance, and legal matters.", url: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Linn County Recorder. Certified copies available for name changes.", url: "https://www.linncountyiowa.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Linn County Clerk of Court. Required for name change passport corrections.", url: "https://www.iowacourts.gov/" },
  ],
};